import { fetchData, apiURL } from './api_helper';

const createAssignments = config => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments`;
  fetchData(endpointURL, 'POST', config).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getAssignmentDetails = assignmentId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/${assignmentId}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const updateAssignment = (assignmentId, config) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/${assignmentId}`;
  fetchData(endpointURL, 'PATCH', config).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const deleteAssignment = assignmentId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/${assignmentId}`;
  fetchData(endpointURL, 'DELETE').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const getConnectedTask = lessonId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/lessons/suggestConnectedTasks/${lessonId}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const createGeneratedAssignment = config => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/generated`;
  fetchData(endpointURL, 'POST', config).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const suggestVocabularyForTopics = config => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/suggestVocabularyForTopics`;
  fetchData(endpointURL, 'POST', config).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getAssignmentDetailsForStudent = (assignmentId, studentId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/${assignmentId}/students/${studentId}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const generateLessonForSampleTask = body => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/generateLessonForSampleTask`;
  fetchData(endpointURL, 'POST', body).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getAssignmentByDktId = dktAssignmentId => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/byDktId/${dktAssignmentId}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const updateAssignmentStats = assignmentIds => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/assignments/updateStats`;
  fetchData(endpointURL, 'POST', assignmentIds).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

export default {
  createAssignments,
  getAssignmentDetails,
  updateAssignment,
  deleteAssignment,
  getConnectedTask,
  createGeneratedAssignment,
  suggestVocabularyForTopics,
  getAssignmentDetailsForStudent,
  generateLessonForSampleTask,
  getAssignmentByDktId,
  updateAssignmentStats
};




// WEBPACK FOOTER //
// ./src/api/assignments.js